require('./bootstrap');

import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import PortalVue from 'portal-vue';
import VuePlyr from 'vue-plyr'
import VueClipboard from 'vue-clipboard2';

import Vue from 'vue'

Bugsnag.start({
    apiKey: 'e3eef5cd402e1b691dafd0efdede1a7b',
    plugins: [new BugsnagPluginVue()]
});
Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);

Vue.use(PortalVue)
Vue.use(VuePlyr, {
    plyr: {
        volume: 0.5
    }
  })
Vue.use(VueClipboard)

const files = require.context('./web-components/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// CDN stuff
const CDN = document.head.querySelector('meta[name="CDN_BASE"]').content;
Vue.mixin({
    methods: {
        CDN_GET(file, size = 'none') {
            if (true === ['thumb', 'medium', 'large'].includes(size)) {
                if (-1 === file.indexOf('_' + size)) {
                    return CDN + file.replace('.', '_' + size + '.')
                }
            }
            return CDN + file
        },
        CDN_YOUTUBE(id, version = 0) {
            return 'https://img.youtube.com/vi/' + id + '/' + version + '.jpg'
        },
        ASSET_LINK(path) {
            const APP_ENV = process.env.MIX_APP_ENV === undefined ? 'local' : process.env.MIX_APP_ENV
            let prefix = '';
            
            if ('production' === APP_ENV) {
                prefix = 'https://cdn.mihaaru.com/assets/mhr/build'
            }

            return prefix + path
        },
        ARTICLE_LINK(category, article) {
            const slug = null === category ?
                article.section_tag_slug :
                category

            const APP_ENV = process.env.MIX_APP_ENV === undefined ? 'local' : process.env.MIX_APP_ENV

            let BASE_URL = 'https://mihaaru.mh.lan'
            if ('production' === APP_ENV) {
                BASE_URL = 'https://mihaaru.com'
            }

            return `${BASE_URL}/${slug}/${article.id}`
        }
    }
})

const app = new Vue({
    el: '#portalapp'
})

// function elementInViewport(el) {
//     var top = el.offsetTop;
//     var height = el.offsetHeight;

//     while (el.offsetParent) {
//         el = el.offsetParent;
//         top += el.offsetTop;
//     }

//     return (
//         top >= window.pageYOffset &&
//         (top + height) <= (window.pageYOffset + window.innerHeight)
//     );
// }